import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { useNavigate } from 'react-router-dom'
import { preFixImgUrl } from '@/utils'

const PRIMARY_PURPLE = '#6B5EE1'

const PurpleCheckIcon = () => (
  <span
    className="inline-flex justify-center items-center rounded-full size-5 shrink-0"
    style={{ backgroundColor: PRIMARY_PURPLE }}
    aria-hidden
  >
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 5L4.5 8.5L11 1"
        stroke="white"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
)

type ServiceBlock = {
  image: string
  imageOnLeft: boolean
  titleKey: string
  descKey: string
  featureKeys: string[]
  path: string
}

const SERVICE_BLOCKS: ServiceBlock[] = [
  {
    image: 'd35cb844f9037ac8d93dad4a7585b9dd.png',
    imageOnLeft: true,
    titleKey: '54f65e85',
    descKey: '860ac988',
    featureKeys: ['d9b6bfba', '1e8c93e3', '0f85fd7d', '1269f37a'],
    path: '/haneda-shop',
  },
  {
    image: '6fe113e79862e94b0935e9fc1e9cfc1f.png',
    imageOnLeft: false,
    titleKey: '57e322d7',
    descKey: 'c4a60325',
    featureKeys: ['7ac772cf', 'f0fec48f', 'f58daef1', '9642d9ec'],
    path: '/sagawa-exp',
  },
  {
    image: '2684271a5962700c6640b3950420d57a.png',
    imageOnLeft: true,
    titleKey: '127c9e7e',
    descKey: '3930ed6e',
    featureKeys: ['ce88427d', '2da4b162', 'de3a4ea0', '4bd330c5'],
    path: '/vip',
  },
  {
    image: 'b9d95142582f599c53d550b034727807.png',
    imageOnLeft: false,
    titleKey: '88f51026',
    descKey: '983acf36',
    featureKeys: ['309abac2', '26ef20e6', '2d9effc1', '6daa118f'],
    path: '/coupon-list',
  },
  // {
  //   image: '6d3162e19f80389440d3da6e1d207c6c.png',
  //   imageOnLeft: true,
  //   titleKey: 'b43302de',
  //   descKey: '0508676a',
  //   featureKeys: ['80603592', '780c876a', '19c3a483', 'e8e80dd1'],
  //   path: '/car-rental',
  // },
]

const ServiceCenter = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="pb-20 bg-[#F8F6FF]">
      {/* Hero */}
      <div className="relative flex min-h-[480px] w-full items-center justify-center overflow-hidden bg-neutral-900">
        <div
          className="absolute inset-0 bg-center bg-no-repeat bg-cover"
          style={{ backgroundImage: `url(${preFixImgUrl('babaebd71924823f4b8e0a74ad71c922.png')})` }}
        />
        <div className="flex relative z-10 flex-col items-center px-10 py-16 mx-auto max-w-full text-center text-white w-8xl">
          <LangText lngKey="ea8f2288" className="text-[50px] font-bold leading-tight md:text-[52px] lg:text-[58px]">
            {t('ea8f2288')}
          </LangText>
          <div className="mt-6 flex max-w-3xl flex-row gap-2 text-[18px] leading-relaxed opacity-95 md:text-[22px] lg:text-[24px]">
            <LangText lngKey="9a53ebd6">{t('9a53ebd6')}</LangText>
          </div>
        </div>
      </div>

      {/* Service sections */}
      {SERVICE_BLOCKS.map((block) => (
        <section key={block.titleKey}>
          <div
            className={`mx-auto flex w-7xl max-w-full flex-col items-center gap-12 px-10 pt-10 md:flex-row md:gap-16 md:pt-12 ${
              block.imageOnLeft ? '' : 'md:flex-row-reverse'
            }`}
          >
            <div className="flex w-full shrink-0 justify-center md:w-[min(50%,560px)]">
              <img
                src={preFixImgUrl(block.image)}
                alt=""
                className="h-auto w-full max-w-[560px] object-contain"
              />
            </div>
            <div className="flex flex-col flex-1 min-w-0">
              <LangText
                lngKey={block.titleKey}
                className="inline-block bg-clip-text text-[32px] font-bold leading-snug text-transparent md:text-[36px] bg-[linear-gradient(270deg,#A75AFF_0%,#4B51FF_100%)]"
              >
                {t(block.titleKey)}
              </LangText>
              <LangText
                lngKey={block.descKey}
                className="mt-8 text-[18px] leading-[1.6] text-[#666666] md:text-[20px] text-left"
                style={{ textAlign: 'justify' }}
              >
                {t(block.descKey)}
              </LangText>
              <ul className="flex flex-col gap-5 mt-8">
                {block.featureKeys.map((key) => (
                  <li key={key} className="flex gap-3 items-start">
                    <PurpleCheckIcon />
                    <LangText lngKey={key} className="text-[18px] leading-snug text-neutral-800 md:text-[20px]">
                      {t(key)}
                    </LangText>
                  </li>
                ))}
              </ul>
              <button
                type="button"
                className="mt-10 h-14 w-fit cursor-pointer rounded-full bg-[linear-gradient(270deg,#A75AFF_0%,#4B51FF_100%)] px-12 text-[18px] font-medium text-white transition-opacity hover:opacity-90 md:text-[20px]"
                onClick={() => navigate(block.path)}
              >
                <LangText lngKey="f8a58b1a" className="text-[18px] text-white md:text-[20px]">
                  {t('f8a58b1a')}
                </LangText>
              </button>
            </div>
          </div>
        </section>
      ))}
    </div>
  )
}

export default ServiceCenter
